import { Box, FilterChip, Menu, Text } from '@zillow/constellation-10';
import { IconChevronDownFilled } from '@zillow/constellation-icons';

interface CustomFilterChipWithMenuProps {
  options: Array<{
    label: string;
    value: string;
  }>;
  text: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  selectedValue?: string;
}

export const CustomFilterChipWithMenu = ({
  options,
  disabled = false,
  selectedValue = '',
  onChange,
  text,
}: CustomFilterChipWithMenuProps) => {
  const selectedOption = options.find((option) => option.value === selectedValue);

  return (
    <Menu
      content={
        <Box css={{ minWidth: '250px', maxHeight: '300px', overflow: 'auto' }}>
          {options.map((option) => (
            <Menu.Item key={option.value} onClick={() => onChange(option.value)}>
              <Menu.ItemLabel>
                <Text textStyle={selectedValue === option.value ? 'body-bold' : 'body'}>{option.label}</Text>
              </Menu.ItemLabel>
            </Menu.Item>
          ))}
        </Box>
      }
      trigger={
        <FilterChip.Root selected={false} disabled={disabled}>
          <FilterChip.Label>{selectedOption?.label || text}</FilterChip.Label>
          <FilterChip.Icon css={{ marginRight: '0', marginLeft: '200' }}>
            <IconChevronDownFilled />
          </FilterChip.Icon>
        </FilterChip.Root>
      }
    />
  );
};
